import ProductHeaders from '@/constants/productHeaders';

/*********************************************
 * Part of "Move Tips and Tricks/Product Notes aside"
 * https://app.asana.com/0/1205146388025688/1205944872379948/f
 ********************************************/

const { TIPS_AND_TRICKS, PRODUCT_NOTES } = ProductHeaders;

function isAsideHeader(header) {
  return [TIPS_AND_TRICKS, PRODUCT_NOTES].indexOf(header?.text) >= 0;
}

function isAsideHeaderName(headerName) {
  return [TIPS_AND_TRICKS, PRODUCT_NOTES].indexOf(headerName) >= 0;
}

function sortAsideHeadersLast(headerA, headerB) {
  let aAside = isAsideHeaderName(headerA?.text);
  let bAside = isAsideHeaderName(headerB?.text);
  if (aAside && !bAside) return 1;
  if (!aAside && bAside) return -1;
  return 0;
}

export {
  isAsideHeader,
  isAsideHeaderName,
  sortAsideHeadersLast,
};